import { Eye, EyeSlash } from '@phosphor-icons/react';
import { useState } from 'react';
import { Input, type InputProps } from './input';

export function PasswordInput({ className, ...props }: Omit<InputProps, 'type'>) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input type={visible ? 'text' : 'password'} className={`pr-11 ${className ?? ''}`} {...props} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
        aria-pressed={visible}
        className="absolute inset-y-0 right-1 my-auto flex size-8 items-center justify-center rounded-control text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        {visible ? <EyeSlash className="size-[18px]" aria-hidden /> : <Eye className="size-[18px]" aria-hidden />}
      </button>
    </div>
  );
}
